<footer>
  <div class="py-3 my-6 bg-gray-50"></div>
  <ng-container *ngIf="router.url === '/home'">
    <div class="container-xl">
      <div class="d-flex flex-column flex-md-row justify-content-center mb-2">
        <h3 class="text-center mt-1">Download the Labcorp Patient mobile app</h3>
        <div class="px-4 text-center">
          <a href="https://apps.apple.com/us/app/labcorp-patient/id1361264072" target="_blank"
            ><img alt="Apple App Store" class="img-fluid me-4" src="assets/images/apple-app-store.svg"
          /></a>
          <a href="https://play.google.com/store/apps/details?id=com.labcorp.patientportal&hl=en_US" target="_blank"
            ><img alt="Google Play" class="img-fluid" src="assets/images/google-play.svg"
          /></a>
        </div>
      </div>
    </div>
    <div class="container-xl mb-6">
      <div class="row justify-content-center">
        <div class="col-md-8 col-lg-7">
          <p class="small mb-0">
            Apple and the Apple logo are trademarks of Apple Inc., registered in the U.S. and other countries. App Store is a service mark
            of Apple Inc., registered in the U.S. and other countries. Google Play and the Google Play logo are trademarks of Google LLC.
          </p>
        </div>
      </div>
    </div>
    <hr class="m-0" />
  </ng-container>
  <div class="bg-white pt-4 pt-md-6">
    <div class="container-xl">
      <div class="row">
        <div class="col-md-3">
          <a href="https://www.labcorp.com/" target="_blank"
            ><img alt="Labcorp" class="footer-logo mb-6" src="assets/images/Labcorp_Logo.svg"
          /></a>
        </div>
        <div class="col-md-9">
          <!-- Desktop View -->
          <div class="row d-none d-md-flex mb-3">
            <div class="col-md-4">
              <h4 class="mt-0 text-black">Guest Services</h4>
              <ul class="list-unstyled">
                <li class="mb-3"><a href="https://www.labcorp.com/precheck" target="_blank">Make an Appointment</a></li>

                <li class="mb-3">
                  <a href="https://patient.labcorp.com/invoices/find">Billing and Insurance</a>
                </li>
                <li class="mb-3">
                  <a href="https://patient.labcorp.com/litholink" target="_blank">Order an At-home 24 Hour Urine Kit </a>
                </li>
              </ul>
            </div>
            <div class="col-md-4">
              <h4 class="mt-0 text-black">Labcorp Patient</h4>
              <ul class="list-unstyled">
                <li class="mb-3">
                  <a href="https://patient.labcorp.com/auth">Sign In</a>
                </li>
                <li class="mb-3">
                  <a href="https://patient.labcorp.com/account/registration/register">Create an Account</a>
                </li>
              </ul>
            </div>
            <div class="col-md-4">
              <h4 class="mt-0 text-black">Get Help</h4>
              <ul class="list-unstyled">
                <li class="mb-3">
                  <a routerLink="/home" target="_blank">Help Center</a>
                </li>
                <li class="mb-3">
                  <a
                    href="{{
                      isRegisteredUser
                        ? 'https://www.labcorp.com/contact-us/labcorp-patient-portal'
                        : 'https://www.labcorp.com/help/contact-info-for-patient/patient-portal-inquiry'
                    }}"
                    target="_blank"
                    >Contact Us</a
                  >
                </li>
              </ul>
            </div>
          </div>
          <!-- Mobile View -->
          <div class="row d-md-none mb-3">
            <div class="col-md-12">
              <ul class="custom-footer-accordion">
                <li>
                  <a class="d-flex align-items-center" [routerLink]="[]" [class.active]="active[0]" (click)="toggleSection(0)">
                    <span class="flex-fill">Guest Services</span>
                    <i class="material-icons-round footer-bottom-link">{{ active[0] ? 'expand_less' : 'expand_more' }}</i>
                  </a>
                  <ul class="content pt-0" [class.collapse]="!active[0]">
                    <li>
                      <a href="https://www.labcorp.com/precheck" class="small" target="_blank">Make an Appointment</a>
                    </li>
                    <li>
                      <a href="https://patient.labcorp.com/invoices/find" class="small">Billing and Insurance</a>
                    </li>
                    <li>
                      <a href="https://patient.labcorp.com/litholink" class="small" target="_blank">Order an At-home 24 Hour Urine Kit </a>
                    </li>
                  </ul>
                </li>
                <li>
                  <a class="d-flex align-items-center" [routerLink]="[]" [class.active]="active[1]" (click)="toggleSection(1)">
                    <span class="flex-fill">Labcorp Patient</span>
                    <i class="material-icons-round footer-bottom-link">{{ active[1] ? 'expand_less' : 'expand_more' }}</i>
                  </a>
                  <ul class="content pt-0" [class.collapse]="!active[1]">
                    <li>
                      <a href="https://patient.labcorp.com/auth" class="small">Sign In</a>
                    </li>
                    <li>
                      <a href="https://patient.labcorp.com/account/registration/register" class="small">Create an Account</a>
                    </li>
                  </ul>
                </li>
                <li>
                  <a class="d-flex align-items-center" [routerLink]="[]" [class.active]="active[2]" (click)="toggleSection(2)">
                    <span class="flex-fill">Get Help</span>
                    <i class="material-icons-round footer-bottom-link">{{ active[2] ? 'expand_less' : 'expand_more' }}</i>
                  </a>
                  <ul class="content pt-0" [class.collapse]="!active[2]">
                    <li>
                      <a routerLink="/home" class="small" target="_blank">Help Center</a>
                    </li>
                    <li>
                      <a
                        href="{{
                          isRegisteredUser
                            ? 'https://www.labcorp.com/contact-us/labcorp-patient-portal'
                            : 'https://www.labcorp.com/help/contact-info-for-patient/patient-portal-inquiry'
                        }}"
                        class="small"
                        target="_blank"
                        >Contact Us</a
                      >
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-navy py-4">
      <div class="container-xxl text-white">
        <div class="col-12">
          <div class="d-flex flex-wrap justify-content-center text-center">
            <ul class="list-inline mb-5">
              <li class="list-inline-item mx-2 mb-2">
                <a href="https://www.labcorp.com/terms-and-conditions" target="_blank" class="text-white"
                  >Terms and Conditions</a
                >
              </li>
              <li class="list-inline-item mx-2 mb-2">•</li>
              <li class="list-inline-item mx-2 mb-2">
                <a href="https://www.labcorp.com/hipaa-privacy" target="_blank" class="text-white">Privacy Policy</a>
              </li>
              <li class="list-inline-item mx-2 mb-2">•</li>
              <li class="list-inline-item mx-2 mb-2">
                <a href="https://patient.labcorp.com/user-agreement" target="_blank" class="text-white"
                  >Patient Portal User Agreement</a
                >
              </li>
              <li class="list-inline-item mx-2 mb-2">•</li>
              <li class="list-inline-item mx-2 mb-2">
                <a
                  href="#"
                  (click)="$event.preventDefault()"
                  class="ot-sdk-show-settings text-white"
                  title="Labcorp.com Do Not Sell or Share My Personal Information (Opens modal popup)"
                  >Do Not Sell or Share My Personal Information</a
                >
              </li>
              <li class="list-inline-item mx-2 mb-2">•</li>
              <li class="list-inline-item mx-2 mb-2">
                <a
                  href="https://www.labcorp.com/patients/bill-pay/payment-options/no-surprises-act"
                  target="_blank"
                  class="text-white"
                  >No Surprises Act</a
                >
              </li>
              <li class="list-inline-item mx-2 mb-2">•</li>
              <li class="list-inline-item mx-2 mb-2">
                <a href="https://www.labcorp.com/labcorp-nondiscrimination-notice" target="_blank" class="text-white"
                  >Notice of Nondiscrimination</a
                >
              </li>
            </ul>
          </div>
          <div class="d-flex flex-wrap justify-content-center text-center">
            <small> Labcorp Patient™ © {{ appYear }} Laboratory Corporation of America® Holdings. All Rights Reserved. </small>
          </div>
        </div>
      </div>
    </div>
  </div>
</footer>
